<h2 mat-dialog-title>
  <button *ngIf="abierta" class="volver" type="button" (click)="volver()" aria-label="Volver a la lista">
    <mat-icon>arrow_back</mat-icon>
  </button>
  {{ abierta ? abierta.subject : 'Comunicaciones recibidas' }}
</h2>

<mat-dialog-content>
  <div *ngIf="cargando" class="centro"><mat-spinner diameter="32"></mat-spinner></div>
  <p *ngIf="error" class="aviso">{{ error }}</p>

  <!-- Lista -->
  <ng-container *ngIf="!cargando && !error && !abierta">
    <p *ngIf="lista.length === 0" class="aviso">Todavía no has recibido ninguna comunicación.</p>
    <button *ngFor="let c of lista" class="fila" type="button" (click)="abrir(c)">
      <span class="fecha">{{ c.fecha | date:'dd/MM/yyyy' }}</span>
      <span class="asunto">{{ c.subject }}</span>
      <mat-icon *ngIf="c.adjunto" class="clip" [attr.aria-label]="'Con adjunto: ' + c.adjunto">attach_file</mat-icon>
    </button>
  </ng-container>

  <!-- Detalle -->
  <ng-container *ngIf="abierta">
    <div class="meta">
      <span><mat-icon>person</mat-icon>{{ abierta.from }}</span>
      <span><mat-icon>schedule</mat-icon>{{ abierta.fecha | date:'dd/MM/yyyy HH:mm' }}</span>
      <span *ngIf="abierta.adjunto"><mat-icon>attach_file</mat-icon>{{ abierta.adjunto }} (adjunto en el correo)</span>
    </div>
    <mat-divider></mat-divider>
    <div *ngIf="cargandoDetalle" class="centro"><mat-spinner diameter="32"></mat-spinner></div>
    <app-vista-correo *ngIf="!cargandoDetalle && abierta.htmlBody" [html]="abierta.htmlBody"></app-vista-correo>
    <p *ngIf="!cargandoDetalle && !abierta.htmlBody" class="aviso">No se ha podido cargar el contenido.</p>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
